module.exports = __webpack_public_path__ + "img/spartan-masonry-concrete-tile-05.d676b825.jpg";